import NwApiSDK from '@nerdwallet/nw-api-sdk';
import appConfig from '@nerdwallet/app-config';

const nwApiSDK = NwApiSDK({
  applicationID: 'my nerdwallet next',
  clientID: 'my-nerdwallet-next',
  cookieDomain: appConfig.API.COOKIE_DOMAIN,
  identifyUrl: appConfig.IDENTIFY_URL,
  identityBaseUrl: appConfig.IDENTITY_BASE_URL,
  diyServicesBaseUrl: appConfig.DIYSERVICES_BASE_URL,
});

export default nwApiSDK;
